import React, { useState, useEffect, useRef } from 'react';
import './WerewolfChat.css';

function WerewolfChat({ messages, onSendMessage, myName }) {
  const [inputMessage, setInputMessage] = useState('');
  const messagesEndRef = useRef(null);
  const chatContainerRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmedMessage = inputMessage.trim();
    if (trimmedMessage && onSendMessage) {
      onSendMessage(trimmedMessage);
      setInputMessage('');
    }
  };

  return (
    <div className="werewolf-chat-container" ref={chatContainerRef}>
      <div className="werewolf-chat-header">
        <h4>💬 Chat Sói</h4>
      </div>
      <div className="werewolf-chat-messages">
        {messages.length === 0 ? (
          <div className="werewolf-chat-empty">
            <p>Chưa có tin nhắn. Hãy bắt đầu thảo luận!</p>
          </div>
        ) : (
          messages.map((msg, index) => (
            <div
              key={index}
              className={`werewolf-chat-message ${msg.senderName === myName ? 'own-message' : ''}`}
            >
              <div className="werewolf-chat-message-header">
                <strong>{msg.senderName}:</strong>
              </div>
              <div className="werewolf-chat-message-text">{msg.text}</div>
            </div>
          ))
        )}
        <div ref={messagesEndRef} />
      </div>
      <form className="werewolf-chat-input-form" onSubmit={handleSubmit}>
        <input
          type="text"
          className="werewolf-chat-input"
          value={inputMessage}
          onChange={(e) => setInputMessage(e.target.value)}
          placeholder="Nhập tin nhắn..."
          maxLength={200}
        />
        <button type="submit" className="werewolf-chat-send-button">
          Gửi
        </button>
      </form>
    </div>
  );
}

export default WerewolfChat;

